@if (isIE10orLower()) {
  <section class="container not-supported-browser">
    <p>Internet Explorer versions 10 and lower are not supported</p>
    <p>Please use Google Chrome, Firefox, Edge or IE 11</p>
  </section>
}

@if (!isIE10orLower()) {
  <div class="app-outer">
    <ngx-spinner name="loadingSpinner" type="ball-scale-multiple"></ngx-spinner>
    <header class="app-header">
      <div class="top-menu row">
        <section class="col-md-8 col-xs-12">
          <a href="http://www2.gov.bc.ca/" tabindex="1"><img class="header-logo" alt="B.C. Government Logo" src="assets/bc-logo.svg"></a>
          <span class="title" role="banner">{{title}}</span>
        </section>
        <section class="col-md-4 col-xs-12 sign-container">
          @if (isAuthenticated) {
            <span class="sign-user">{{ authUsername }}</span>
            <button class="btn btn-outline btn-sm sign-out-btn" (click)="logout()">Sign Out</button>
          }
        </section>
      </div>
    </header>
    <div class="app-body">
      <main class="app-content">
        <div class="app-main">
          @if (showAlert) {
            <app-alert [message]="alertMessage" type="danger"></app-alert>
          }
          <breadcrumb></breadcrumb>
          <router-outlet></router-outlet>
        </div>
      </main>
      <app-quick-exit></app-quick-exit>
    </div>
    <footer class="app-footer">
      <nav class="navbar navbar-default navbar-expand navbar-footer navbar-static-bottom">
        <div class="container">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link" href="https://www2.gov.bc.ca/gov/content/home" target="_blank">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://www2.gov.bc.ca/gov/content/about-gov-bc-ca" target="_blank">About gov.bc.ca</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://www2.gov.bc.ca/gov/content/home/disclaimer" target="_blank">Disclaimer</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://www2.gov.bc.ca/gov/content/home/privacy" target="_blank">Privacy</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://www2.gov.bc.ca/gov/content/home/accessible-government" target="_blank">Accessibility</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://www2.gov.bc.ca/gov/content/home/copyright" target="_blank">Copyright</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://www2.gov.bc.ca/gov/content/home/get-help-with-government-services" target="_blank">Contact us</a>
            </li>
          </ul>
        </div>
      </nav>
    </footer>
  </div>
}